import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CalendarPage from '../CalendarItem/DashboardCalendar';
import DonutChart from './DonutChart';
import BarChart from './Barchart';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import ModalType from '../../../pages/Badge/modalBadges';
import ClassCarosel from './ClassCarosel';
import ClassStatistics from './ClassStatistics';
import LiveClasses from '../LiveClasses/liveClasses';

const LearnerItem = () => {
  const [totalClass, setTotalClass] = useState(0);
  const [addTypeModal, setAddTypeModal] = useState(false);

  return (
    <>
      <div className="container learner-cardbody" style={{ marginTop: -20 }}>
        <section>
          <div className="row">
            <div className="col-md-4">
              <ClassStatistics setTotalClass={setTotalClass} />
            </div>
            <div className="col-md-3">
              <ClassCarosel />
            </div>
            <div className="col-md-5">
              <h6 className="heading_text_title">My Calendar</h6>

              <CalendarPage dayOrMonth="dayGridMonth" learner="learner" />
            </div>
          </div>
        </section>
        <section style={{ marginTop: 25 }}>
          <div className="row">
            <div className="col-md-4">
              <div className="col-md-12 m-0 p-0">
                <div className="bar-chart-carddesign">
                  <div className="card-body">
                    <BarChart />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="col-lg-12 m-0 p-0">
                <div className="bar-chart-carddesign">
                  <div className="card-body">
                    <div className="row">
                      <DonutChart totalClass={totalClass} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-5 learner_live_classes">
              <div className="live_classes">
                <LiveClasses />
              </div>
            </div>
          </div>
        </section>

        <ModalType open={addTypeModal} toggle={() => setAddTypeModal(false)} />
      </div>
    </>
  );
};

LearnerItem.propTypes = {
  course: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default LearnerItem;
